import React, { useReducer } from 'react';
import ShoppingContext from './shoppingContext';
import ShoppingReducer from './shoppingReducer';

const LiveState = (props) => {
  const initialState = {
    freeShipping: [
      {
        id: 1,
        // src: img1,
        heading: 'Throwdown Chapter IV: Laser Jail',
        price: '₹ 2,418',
        // quantity:'',
        // size:''
      },
      {
        id: 2,
        // img: '',
        heading: 'Throwdown Chapter III: Laser Jail',
        price: '₹ 2,418',
        // quantity:'',
        // size:''
      },
      // {
      //   id: 3,
      //   // img: '',
      //   heading: 'Throwdown Chapter III: Laser Jail',
      //   price: '₹ 2,418',
      //   // quantity:'',
      //   // size:''
      // },
    ],
  };
  const [state] = useReducer(ShoppingReducer, initialState);

  return (
    <ShoppingContext.Provider
      value={{
        freeShipping: state.freeShipping,
      }}
    >
      {props.children}
    </ShoppingContext.Provider>
  );
};

export default LiveState;
